import type { AxiosError, AxiosInstance } from "axios";
import apm from "../apm";

export function setupApmInterceptor(client: AxiosInstance): void {
  client.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      try {
        const message =
          (error.response?.data as any)?.message ||
          error.message ||
          "API request error";

        apm.setCustomContext({
          request: {
            url: error.config?.url,
            method: error.config?.method,
            data: error.config?.data,
          },
          response: {
            status: error.response?.status,
            data: error.response?.data,
          },
        });

        apm.captureError(message);
      } catch {
        console.log("Error capturing error for APM");
      }

      return Promise.reject(error);
    },
  );
}
